import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../../imup/types'

export const uiSchema: UiSchema = {}

const onValidate = () => {}

const onSubmit = (settings, formData) => {
    return { ...settings, ...formData }
}

const form: FormProperties = { uiSchema, onValidate, onSubmit }

export default form
